import apiClient from './mobileAuthService'
import { USE_JWT_COOKIE } from '../../shared/auth/authConfig.js'

/**
 * モバイル設定サービス
 * アプリケーション設定、アップロード設定、ローカル保存設定などの管理機能を提供
 */
export const mobileConfigService = {
  /**
   * 設定情報の取得
   * アプリケーションの基本設定情報をサーバーから取得
   * @returns {Promise<Object>} 設定情報
   */
  async getConfig() {
    const response = await apiClient.post('/appConfig', {})
    return response.data
  },

  /**
   * アップロード設定の取得
   * ファイルアップロードに関する設定情報を取得
   * @returns {Promise<Object>} アップロード設定情報
   */
  async getUploadConfig() {
    const response = await apiClient.post('/getUploadConfig', {})
    return response.data
  },

  /**
   * アップロード設定の更新
   * ファイルアップロードに関する設定を更新
   * @param {Object} uploadConfig - アップロード設定データ
   * @returns {Promise<Object>} 更新結果
   */
  async updateUploadConfig(uploadConfig) {
    const response = await apiClient.post('/updateUploadConfig', {
      uploadConfig: uploadConfig
    })
    return response.data
  },

  /**
   * ローカル保存設定の更新
   * ファイルのローカル保存に関する設定を更新
   * @param {boolean} saveLocal - ローカル保存の有効/無効
   * @returns {Promise<Object>} 更新結果
   */
  async updateSaveLocal(saveLocal) {
    const response = await apiClient.post('/updateSaveLocal', {
      saveLocal: saveLocal
    })
    // JWTトークンを更新
    if (response.data.token && !USE_JWT_COOKIE) {
      localStorage.setItem('token', response.data.token)
    }
    return response.data
  }
}

export default mobileConfigService
